// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iK","advertCardFooter__row":"c-a_iL","advertCardFooter__name":"c-a_iM","advertCardFooter__price":"c-a_iN","advertCardFooter__age":"c-a_iO"};